import {SearchRules, SearchType} from '../rules';

/**
 * Check if search rules contain a specific search type
 * @param searchRules
 * @param searchType
 * @returns Search rules contain a specific search type
 */
export const searchRulesContainType = (
	searchRules: SearchRules,
	searchType: SearchType,
) =>
	searchRules.elementTypes.some(
		(searchRuleType) => searchRuleType === searchType,
	);

export default searchRulesContainType;
